module.exports = __webpack_public_path__ + "img/scalability-1.dbf892a1.png";